<template>
  <div class="app-container">
    <!-- 输入框 + 查询按钮 -->
    <el-input
      v-model="companyName"
      placeholder="请输入公司名"
      style="width: 300px; margin-right: 10px;"
      clearable
    ></el-input>
    <el-button type="primary" @click="handleSearch">查询</el-button>

    <!-- 表格 -->
    <el-table
      v-if="tableData.length > 0"
      :data="tableData"
      border
      stripe
      style="margin-top: 20px; width: 100%;"
    >
      <el-table-column prop="companyName" label="公司名称" width="300"></el-table-column>
<!--      <el-table-column prop="name" label="账户名"></el-table-column>-->
<!--      <el-table-column prop="email" label="邮箱"></el-table-column>-->
<!--      <el-table-column prop="cashBalance" label="现金余额"></el-table-column>-->
<!--      <el-table-column prop="consumeAmount" label="累计消耗"></el-table-column>-->
<!--      <el-table-column prop="todayConsumeAmount" label="今日消耗"></el-table-column>-->
<!--      <el-table-column prop="yesterdayConsumeAmount" label="昨日消耗"></el-table-column>-->
<!--      <el-table-column prop="region" label="所属地区"></el-table-column>-->
      <el-table-column prop="openTime" label="开户时间"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      companyName: "",
      tableData: []
    };
  },
  methods: {
    async handleSearch() {
      if (!this.companyName) {
        this.$message.warning("请输入公司名");
        return;
      }

      try {
        const res = await axios.get(
          `https://control.zjwec.cn/api/vivo/qrshzt?name=${encodeURIComponent(this.companyName)}`
        );

        if (res.data && res.data.length > 0) {
          this.tableData = res.data;
        } else {
          this.tableData = [];
          this.$message.warning("暂未发现该公司的开户数据");
        }
      } catch (error) {
        this.$message.error("查询失败：" + error.message);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/vivo/XsQrKh.vue